// extracted by mini-css-extract-plugin
export default {"wrapper":"EditPostModal_wrapper__djjs-","postCard":"EditPostModal_postCard__Xn1To","header":"EditPostModal_header__FXuUM","title":"EditPostModal_title__8oBF0"};